import { ALL_USER_ROLES } from '../../constants/roles/userRoleTypes';

const {
    ASSISTERENROLLMENTENTITY,ASSISTERENROLLMENTENTITYADMIN
} = ALL_USER_ROLES;

export const fields = {
    CEC_FIRST_NAME : 'firstName',
    CEC_LAST_NAME : 'lastName',
    CEC_STATUS:'status',
    CEC_EMAIL:'emailAddress',
    CEC_LICENCE_NUMBER : 'assisterNumber',
    CEC_NAME : 'cecName',
    CEC_RD_BTN:'pickCEC',
    CEC_EXPORT_BTN:'exportBtn',
    ENTITY_SITE : 'primarySite',    
    PRIMARY_SITE : 'primarySiteLabel',
    ENTITY_NAME : 'entityName',
    ENTITY_FEDERAL_TAX_ID : 'entityFederalTaxId',
    BOB_REASSIGN_BTN : 'bobReassignBtn'
};


export const labelNames = {
    [fields.CEC_FIRST_NAME]: 'common.cec_first_name',
    [fields.CEC_LAST_NAME]: 'common.cec_last_name',
    [fields.CEC_NAME]:'common.cecFullName',
    [fields.CEC_STATUS]:'common_cec_status',
    [fields.CEC_EMAIL] :'common.cec_email',
    [fields.CEC_LICENCE_NUMBER] :'common.cec_license_number',
    [fields.CEC_RD_BTN]:'common.cec_rd_btn',
    [fields.CEC_EXPORT_BTN]:'common.cec_export_btn' ,
    [fields.ENTITY_SITE]:'common.entity_site',
    [fields.PRIMARY_SITE]:'cec.primary_site',

    [fields.ENTITY_NAME] :'common.entity_name',
    [fields.ENTITY_FEDERAL_TAX_ID] : 'common.entity_federal_tax_id',
    [fields.BOB_REASSIGN_BTN] : 'common.bob_reassign_btn'
};

export const headersByType ={
    [fields.CEC_EXPORT_BTN] :'link',
    [fields.BOB_REASSIGN_BTN] :'button'
};

export const tableHeadersByRole = {    
    [ASSISTERENROLLMENTENTITY]:[
        fields.CEC_RD_BTN,
        fields.CEC_NAME,        
        fields.CEC_STATUS,
        fields.CEC_EMAIL,
        fields.PRIMARY_SITE,

        fields.CEC_EXPORT_BTN
    ],
    [ASSISTERENROLLMENTENTITYADMIN] :[
        fields.CEC_RD_BTN,
        fields.ENTITY_NAME,
        fields.ENTITY_FEDERAL_TAX_ID,
        fields.CEC_NAME,        
        fields.CEC_LICENCE_NUMBER,
        fields.CEC_STATUS,
        fields.BOB_REASSIGN_BTN
    ]
};

export const DELEGATION_FILTER_TITLE_TYPES = {    
    [ASSISTERENROLLMENTENTITY]:'CEC_filter_title_for_export_by_entitymgr',
    [ASSISTERENROLLMENTENTITYADMIN]:'EntityAdmin_CEC_filter_title_for_export',
};

export const filtersByRole = {
    [ASSISTERENROLLMENTENTITY]:[
        fields.CEC_FIRST_NAME,
        fields.CEC_LAST_NAME,
        fields.ENTITY_SITE,
        fields.CEC_EMAIL,
        fields.CEC_LICENCE_NUMBER        
    ],
    [ASSISTERENROLLMENTENTITYADMIN]:[
        fields.ENTITY_NAME,
        fields.ENTITY_FEDERAL_TAX_ID,
        fields.CEC_FIRST_NAME,
        fields.CEC_LAST_NAME,
        fields.CEC_LICENCE_NUMBER
    ]
};

export const filterInputsMaxLength = {    
    [fields.CEC_FIRST_NAME] : 50,
    [fields.CEC_LAST_NAME] : 50    
};

export const filterInputsMaxLength_CA = {
    [fields.CEC_FIRST_NAME] : 50,
    [fields.CEC_LAST_NAME] : 50    
};

export const DELEGATION_REASONS = {
    AGENT_CEC_CERTIFICATION_ENDED:	'delegation.reasons.certification_ended',
    AGENT_CEC_INITIATED_DEDESIGNATION:	'delegation.reasons.initiated_de_designation',
    CONSUMER_REQUESTED_CANCELLATION:	'delegation.reasons.cancellation',
    TRANSFER_WITHIN_AGENCY_ENTITY: 'delegation.reasons.transfer',
    ACCELERATED_CONSUMER_DELEGATION_CONSENT: 'delegation.reasons.accelerated'
};

export const DELEGATION_HEADER_TYPES = {    
    [ASSISTERENROLLMENTENTITY]:'CEC_filter_header',
    [ASSISTERENROLLMENTENTITYADMIN]:'EntityAdmin_CEC_filter_header',
};

export const DELEGATION_ALERT_MSGS = {
    DEFAULT: 'CEC_no_result_found',    
    ENTITYADMIN_PAGE_LOAD : 'assister_page_load'
};